import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppErrorComponent } from './components/app-error/app-error.component';

const routes: Routes = [
  {
    path: 'error',
    component: AppErrorComponent,
    children: [
      
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedRoutingModule { }
